import { appConst } from "../../AppConst";
import { ILoginOIDCRequest } from "../../model/request/auth/ILoginOIDCRequest";
import { axiosClient } from "../axiosClient";

export const loginApi = {
    login: (request: ILoginOIDCRequest) => axiosClient.post(`${appConst.baseApiURL}/account/login`, request)
}